module.exports = __webpack_public_path__ + "img/map_right_thum_no.8514513d.png";